import SingleSelect from './SingleSelect.view';
export default SingleSelect;
